import Vue from 'vue'

import { buildQueryParams } from '@/helpers/statusesQueryParams'
import { $themeConfig } from '@themeConfig'

const BACK_URL = $themeConfig.app.backUrl

export function fetchStatusesCount(paramsSearch, signal) {
    return Vue.axios.get(
        `${BACK_URL}/statuses/count?${buildQueryParams({
            ...paramsSearch,
        })}`,
        signal ? { signal } : undefined
    )
}
